<template>
  <div>
    <h2>我的收藏</h2>
    <a-divider></a-divider>
    <a-list
      :grid="{ gutter: 24, xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }"
      :dataSource="dataSource"
      :pagination="pagination"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card class="work-card">
          <div class="work-cover">
            <a @click="toWorkDetail(item)" target="_blank" class="img-zoom">
              <img v-if="item.workCover" :src="item.workCover_url" />
              <img v-else :src="getCodeIcon(item.codeType)" />
            </a>
          </div>
          <a-row class="work-author">
            <a-col :span="6">
              <a-avatar
                shape="square"
                class="avatar"
                :size="40"
                :src="item.avatar?item.avatar_url:'/img/avatar.png'"
                @click="toUserInfo(item)"
                style="cursor: pointer"
              />
            </a-col>
            <a-col :span="18">
              <span @click="toUserInfo(item)" style="cursor: pointer">{{
                item.realname || item.username
              }}</span>
            </a-col>
          </a-row>
          <a-divider></a-divider>
          <div class="work-op">
            <a @click="toWorkDetail(item)">{{ item.workName }}</a>
            <a-row type="flex" justify="between-around">
              <a-col :span="6">
                <a-icon type="eye" /> {{ item.viewNum }}
              </a-col>
              <a-col :span="6">
                <a-icon type="like" /> {{ item.starNum }}
              </a-col>
              <a-col :span="10">
                <a-popconfirm
                  title="确定删除收藏吗?"
                  @confirm="() => collectWork(item.id)"
                >
                  <a><a-icon type="delete" /></a>
                </a-popconfirm>
              </a-col>
            </a-row>
          </div>
        </a-card>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import "@/assets/less/animation.css";
import { deleteAction, getAction, downFile } from "@/api/manage";
import QrCode from "@/components/tools/QrCode";
export default {
  components: {
    qrcode: QrCode,
  },
  data() {
    return {
      queryParam: {},
      pagination: {
        onChange: this.pageChange,
        pageSize: 8,
      },
      dataSource: [],
      url: {
        list: "/teaching/teachingWork/myCollectWork",
        delete: "/teaching/teachingWork/delete",
        shareUrl:
          window._CONFIG["webURL"] + '/work/detail?workId=',
      },
    };
  },
  mounted() {
    this.pageChange(1, 6);
  },
  methods: {
    pageChange(page, pageSize) {
      this.dataSource = [];
      this.pagination.current = page;
      this.pagination.pageSize = pageSize;
      this.queryParam.pageNo = this.pagination.current;
      this.queryParam.pageSize = this.pagination.pageSize;
      this.getWorkList();
    },
    getWorkList: function () {
      var that = this;
      getAction(that.url.list, this.queryParam).then((res) => {
        if (res.success) {
          that.dataSource = res.result.records;
          that.pagination.total = res.result.total;
        }
        if (res.code === 510) {
          that.$message.warning(res.message);
        }
        that.loading = false;
      });
    },
    toWorkDetail(info) {
      if (info.codeType == 0) {
        this.$router.push("/work/mdView?workId=" + info.id);
      } else {
        this.$router.push("/work/detail?workId=" + info.id);
      }
    },
    collectWork(workId) {
      getAction("/teaching/teachingWork/collectWork?workId=" + workId).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.pageChange(1, 6);
          }
        }
      );
    },
    getCodeIcon(codeType) {
      switch (codeType) {
        case 0:
          return require("@/assets/icon/markdown.png");
        case 4:
          return require("@/assets/icon/turtle.png");
        case 5:
          return require("@/assets/icon/python.png");
        case 6:
          return require("@/assets/icon/c.png");
        case 7:
          return require("@/assets/icon/cpp.png");
        case 8:
          return require("@/assets/icon/java.png");
        default:
          return require("@/assets/icon/code.png");
      }
    },
    getEditorHref(item) {
      switch (item.codeType) {
        case 0:
          return "/work/mdEditor?id=" + item.id;
          break;
        case 1:
          return "/scratch3/index.html?workId=" + item.id;
          break;
        case 2:
          return "/scratch3/index.html?workId=" + item.id;
          break;
        case 3:
          return (
            "/scratchjr/editor.html?mode=edit&filepath=" + item.workFile_url
          );
          break;
        case 4:
          return "/onlinecode/index.html?lang=turtle&workId=" + item.id;
          break;
        case 5:
          return "/onlinecode/index.html?lang=python&workId=" + item.id;
          break;
        case 6:
          return "/onlinecode/index.html?lang=c&workId=" + item.id;
          break;
        case 7:
          return "/onlinecode/index.html?lang=cpp&workId=" + item.id;
          break;
        case 8:
          return "/onlinecode/index.html?lang=java&workId=" + item.id;
          break;
        default:
          return item.workFile_url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.ant-card-extra {
  margin-left: 0 !important;
  height: 55px;
}
.work-card {
  border: none;
  /deep/.ant-card-body {
    width: 250px;
    height: 280px;
    padding: 0;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000039;
  }
  .ant-divider-horizontal {
    margin: 12px 0;
  }
  .work-cover {
    width: 100%;
    max-height: 150px;
    overflow: hidden;
    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
  .work-author {
    padding: 10px 10px 0;
    span {
      line-height: 40px;
    }
  }
  .work-op {
    a {
      color: black;
    }
    a:hover {
      color: #1890ff;
    }
    padding: 0 10px;
  }
}
</style>